import React from "react"
import { type RouteObject } from "react-router-dom"

import { RoutesPaths } from "../../../constants/routes.ts"
import { GuideAcademyModulePage } from "../GuideAcademyModulePage.tsx"
import { GuideHomePage } from "../GuideHomePage.tsx"
import { GuideLessonPage } from "../GuideLessonPage.tsx"
import { GuideProductStoryPage } from "../GuideProductStoryPage.tsx"
import { GuideQAPage } from "../GuideQAPage.tsx"
import { LearnEZBuildPage } from "../LearnEZBuildPage.tsx"
import { GuideTourPreviewLeadPage } from "../tour-preview/GuideTourPreviewLeadPage.tsx"
import { GuideTourPreviewProjectPage } from "../tour-preview/GuideTourPreviewProjectPage.tsx"

// The Guide is available to every authenticated user regardless of the
// backend's per-tenant permission templates (see sidebar-config.tsx), so
// none of these routes sit behind a PermissionGate. The tour-preview routes
// are no exception — they're static and read no real data, so there's
// nothing on them a PermissionGate would meaningfully protect.
export const guideRoutes: RouteObject[] = [
  {
    path: RoutesPaths.guide.home,
    element: <GuideHomePage />
  },
  {
    path: RoutesPaths.guide.story,
    element: <GuideProductStoryPage />
  },
  {
    path: RoutesPaths.guide.academy,
    element: <LearnEZBuildPage />
  },
  {
    path: RoutesPaths.guide.module(":moduleSlug"),
    element: <GuideAcademyModulePage />
  },
  {
    path: RoutesPaths.guide.lesson(":lessonId"),
    element: <GuideLessonPage />
  },
  {
    path: RoutesPaths.guide.qa,
    element: <GuideQAPage />
  },
  {
    path: RoutesPaths.guide.tourPreview.lead,
    element: <GuideTourPreviewLeadPage />
  },
  {
    path: RoutesPaths.guide.tourPreview.project,
    element: <GuideTourPreviewProjectPage section="overview" />
  },
  {
    path: RoutesPaths.guide.tourPreview.projectMilestones,
    element: <GuideTourPreviewProjectPage section="milestones" />
  },
  {
    path: RoutesPaths.guide.tourPreview.projectFinance,
    element: <GuideTourPreviewProjectPage section="finance" />
  },
  {
    path: RoutesPaths.guide.tourPreview.projectInvoices,
    element: <GuideTourPreviewProjectPage section="invoices" />
  },
  {
    path: RoutesPaths.guide.tourPreview.projectFiles,
    element: <GuideTourPreviewProjectPage section="files" />
  },
  {
    path: RoutesPaths.guide.tourPreview.projectActivity,
    element: <GuideTourPreviewProjectPage section="activity" />
  }
]
